module.exports = __webpack_public_path__ + "media/features/landing-page/components/sections/footer-section/background-04fc81858389064827199e7a1219c496.png";